import React from 'react';
import { Icon } from 'semantic-ui-react';
import styled from 'styled-components';

const ToolbarButton = styled.button.withConfig({
  shouldComponentUpdate: true,
  // These props should not be passed to the DOM element
  componentId: 'ToolbarButton',
  shouldComponentUpdate: true,
  // Tell styled-components which props are for styling only
  shouldForwardProp: (prop) => !['recording', 'active', 'hasLabel'].includes(prop),
})`
  display: inline-flex;
  flex-direction: ${props => (props.hasLabel ? 'column' : 'row')};
  align-items: center;
  justify-content: center;
  gap: ${props => (props.hasLabel ? '4px' : '6px')};
  min-width: 36px;
  height: 36px;
  padding: ${props => (props.hasLabel ? '6px 10px' : '0 12px')};
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: ${props => !props.active 
    ? 'linear-gradient(145deg, rgba(239, 68, 68, 0.2) 0%, rgba(220, 38, 38, 0.2) 100%)'
    : props.recording
      ? 'linear-gradient(145deg, rgba(239, 68, 68, 0.2) 0%, rgba(220, 38, 38, 0.2) 100%)'
      : 'linear-gradient(145deg, rgba(96, 165, 250, 0.2) 0%, rgba(59, 130, 246, 0.2) 100%)'
  };
  color: ${props => !props.active ? '#ef4444' : props.recording ? '#ef4444' : '#60a5fa'};
  font-size: 1.1rem;
  cursor: pointer;
  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(8px);
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);

  &:hover {
    background: ${props => !props.active
      ? 'linear-gradient(145deg, rgba(239, 68, 68, 0.25) 0%, rgba(220, 38, 38, 0.25) 100%)'
      : props.recording
        ? 'linear-gradient(145deg, rgba(239, 68, 68, 0.25) 0%, rgba(220, 38, 38, 0.25) 100%)'
        : 'linear-gradient(145deg, rgba(96, 165, 250, 0.25) 0%, rgba(59, 130, 246, 0.25) 100%)'
    };
    transform: translateY(-1px);
    box-shadow: 0 8px 8px -4px rgb(0 0 0 / 0.15), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px -2px rgb(0 0 0 / 0.1);
  }

  i.icon {
    margin: 0 !important;
    font-size: 1.1rem;
    display: block;
  }

  .toolbar-label {
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  }
`;

const RecordingButton = ({ recording, toggleRecording, icon = 'phone', label, active = true, onClick, title }) => {
    // Use provided onClick or fallback to toggleRecording
    const handleClick = onClick || toggleRecording;
  const hasLabel = Boolean(label);
    
    return (
        <div className='button-card'>
            <div className='video-cta'>
                <ToolbarButton
                    recording={recording}
                    active={active}
          hasLabel={hasLabel}
                    onClick={handleClick}
          aria-label={title || label}
                    title={title}
                >
          {icon && (
            <Icon 
              name={
                icon === 'phone' ? (recording ? 'stop' : 'phone') :
                icon === 'video' ? (active ? 'video' : 'ban') :
                icon === 'microphone' ? (active ? 'microphone' : 'microphone slash') :
                'question'
              } 
            />
          )}
          {hasLabel && (
            <span className="toolbar-label">{label}</span>
          )}
                </ToolbarButton>
            </div>
        </div>
    );
};

export default RecordingButton;